"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_type_1 = __importDefault(require("../const/action-type"));
const initial_1 = __importDefault(require("../store/initial"));
const is_defined_1 = require("../util/is-defined");
const filterHasUderId = (t) => 'userId' in t;
exports.default = (state = initial_1.default.calendarFilters, action) => {
    switch (action.type) {
        case action_type_1.default.SET_CALENDAR_FILTERS:
            return action.data;
        default: {
            // remove the old, deprecated calendarFilter types (userId='offers' and oserId='unassigned')
            return (state || [])
                .map((s) => {
                if (filterHasUderId(s) && s.userId === 'offers')
                    return null;
                if (filterHasUderId(s) && s.userId === 'unassigned')
                    return null;
                return s;
            })
                .filter(is_defined_1.isValue);
        }
    }
};
